import Vue from "vue"
import VueRouter from "vue-router"
import Home from "../views/Home.vue"
import Enlightenment from "../views/enlightenment/enlightenment"
import Course from "../views/course/course"
import DownLoad from "../views/downLoad/downLoad"
import Web from "../views/web/web"
import Study from "../views/study/study"
import Exchange from "../views/exchange/exchange"
import Order from "../views/order/order"
import AddTeacher from "../views/add-teacher/add-teacher"
import Index from "../views/index/index"
import Share from "../views/share/share"
import RecommendBind from "../views/recommendBind/recommendBind"
import Recommend from "../views/recommend"
import MyInfo from '../views/my-info'
import RecommendDetail from '../views/recommend-detail'
import BuyDetail from '../views/buy-detail'
import Extract from '../views/extract'
import Shu from '../views/shu'
import NewOrder from '../views/new-order'
import BuySuccess from '../views/buy-success'
import Withdraw from '../views/withdraw'
import Question from '../views/question'
import Sudoku from '../views/sudoku'
Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    component: Index,
    meta: {
      title: "积木AI课"
    }
  },
  {
    path: "/index",
    name: "index",
    component: Index,
    meta: {
      title: "积木AI课"
    }
  },
  {
    path: "/bindMobile",
    name: "Home",
    component: Home,
    meta: {
      title: "绑定学习手机号"
    }
  },
  {
    path: "/enlightenment",
    name: "Enlightenment",
    component: Enlightenment,
    meta: {
      title: "思维启蒙"
    }
  },
  {
    path: "/course",
    name: "Course",
    component: Course,
    meta: {
      title: "思维课程"
    }
  },
  {
    path: "/downLoad",
    name: "DownLoad",
    component: DownLoad,
    meta: {
      title: "下载APP"
    }
  },
  {
    path: "/web",
    name: "Web",
    component: Web,
    meta: {
      title: "积木AI课"
    }
  },
  {
    path: "/study",
    name: "Study",
    component: Study,
    meta: {
      title: "学习报告"
    }
  },
  {
    path: "/exchange",
    name: "Exchange",
    component: Exchange,
    meta: {
      title: "思维+数独体验课"
    }
  },
  {
    path: "/order",
    name: "Order",
    component: Order,
    meta: {
      title: "确认订单"
    }
  },
  {
    path: "/addTeacher",
    name: "AddTeacher",
    component: AddTeacher,
    meta: {
      title: "报名成功"
    }
  },
  {
    path: "/share",
    name: "share",
    component: Share,
    meta: {
      title: "推荐有礼"
    }
  },
  {
    path: "/recommendBind",
    name: "recommendBind",
    component: RecommendBind,
    meta: {
      title: "绑定手机号"
    }
  },
  {
    path: "/recommend",
    name: "recommend",
    component: Recommend,
    meta: {
      title: "加入妈妈推荐官，努力赚分佣。"
    }
  },
  {
    path: "/myInfo",
    name: "myInfo",
    component: MyInfo,
    meta: {
      title: "我的推荐"
    }
  },
  {
    path: "/recommendDetail",
    name: "recommendDetail",
    component: RecommendDetail,
    meta: {
      title: "我的推荐"
    }
  },
  {
    path: "/buyDetail",
    name: "buyDetail",
    component: BuyDetail,
    meta: {
      title: "我的推荐"
    }
  },
  {
    path: "/extract",
    name: "extract",
    component: Extract,
    meta: {
      title: "提取现金"
    }
  },
  {
    path: "/shu",
    name: "shu",
    component: Shu,
    meta: {
      title: "思维启蒙课"
    }
  },
  {
    path: "/newOrder",
    name: "newOrder",
    component: NewOrder,
    meta: {
      title: "立即购买"
    }
  },
  {
    path: "/buySuccess",
    name: "buySuccess",
    component: BuySuccess,
    meta: {
      title: "购买成功"
    }
  },
  {
    path: "/withdraw",
    name: "withdraw",
    component: Withdraw,
    meta: {
      title: "提取现金"
    }
  },
  {
    path: "/question",
    name: "question",
    component: Question,
    meta: {
      title: "常见问题"
    }
  },
  {
    path: "/sudoku",
    name: "sudoku",
    component: Sudoku,
    meta: {
      title: "少儿数独课"
    }
  }
]

const router = new VueRouter({
  routes
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
export default router
